var map = {
	"./cca-pikto-berge.svg": 84234,
	"./cca-pikto-congress.svg": 29676,
	"./cca-pikto-dorf.svg": 35689,
	"./cca-pikto-lage.svg": 92881,
	"./cca-pikto-nachhaltigkeit.svg": 88553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99476;